import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/FeatureAdd";
import { MapListRecordsInViewport } from "esdm-map/dist/map/MapListRecordsInViewport";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";
import { GeoLocation } from "esdm-map/dist/map/geolocation/geolocation";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { MapViewSettingsUrlProvider } from "esdm-map/dist/map/store/MapViewSettingsUrlProvider";
import { IMapViewPermaLink } from "esdm-map/dist/map/tools/IMapViewPermaLink";
import { MapViewPermaLink } from "esdm-map/dist/map/tools/MapViewPermaLink";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IMapViewSettingProvider } from "esdm-map/dist/map/store/IMapViewSettingsProvider";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";

import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapListRecordItem,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    MapFeatureInfo
} from "esdm-map";

import "../wwwroot/css/ol.css";
import "../wwwroot/css/ol3-contextmenu.css";
import "../wwwroot/css/bootstrap-slider.min.css"
import { TextPackLoader, TextPacks } from "./TextPackLoader";

import { MapBase } from "./MapBase";
import { MapToolTip, ToolTipOptions } from "esdm-map/dist/map/tooltip";
import { IDragPan } from "esdm-map/dist/map/controls/interfaces/IDragPan";
import { DragPan } from "esdm-map/dist/map/controls/DragPan";
import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { LhlpIdentity, LhlpUser } from "./defs/LhlpUser";
import { DefaultLayerConfigurationFactory } from "./config/DefaultLayerConfigurationFactory";
import { LhlpStyleFactory } from "./style/LhlpStyleFactory";
import { LhlpResourcefactory } from "./resources/LhlpResourceFactory";
import { DefaultMapOptions } from "./config/DefaultMapOptions";
import { LhlpRecordSubType, LhlpRecordType } from "./defs/LhlpRecordType";
import { LhlpMapListRecordItem } from "./resources/LhlpMapListRecordItem";
import { IWmsLayerGroupConfig } from "esdm-map/dist/layers/groups/wms/interfaces/IWmsLayerGroupConfig";
import { IWmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms/interfaces/IWmsLayerGroupFactory";
import { WmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms";
import { LhlpBaseLayerFactory } from "./Layers/LhlpBaseLayerFactory";
import { LhlpGazetteer } from "./gazetteer/LhlpGazetteer";
import { LhlpMapConfig, LhlpStatusLookup, LhlpTypeLookup } from "./defs/LhlpMapConfig";

$(document).ready(function () {  
    
   $('[data-toggle="tooltip"]').tooltip();          
    let printOptions: PrintMap = new PrintMap();

    if (!printOptions.isPrintMap) {        
        resizeMap();
        $(window).bind('resize', function () { resizeMap(); });
    } 

    function resizeMap() {
        //use max footer height, especially on mobile
        var fHeight = $("footer").height();
        fHeight = Math.min(fHeight, 200);

        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
        $("#slide-content").height(height - 55);
    };



    let ele = $("#theMap");
    if (ele.length === 1) {      
        LhlpIdentity.fetch().then(function (e) {
            //let user = e;
            //if (e) {
            //    console.log(e.userId);
            //} else {
            //    console.log("401 - UnAuthorised");
            //}
            loadMap(e);
        });
    } 

    function loadMap(user: LhlpUser) {
        let maxFeatureCount: number = <number>ele.data("max-feature-count");
        let siteId: string = <string>ele.data("site-id");
        let siteFolder: string = <string>ele.data("site-folder");
        let mapConfigB64: string = <string>ele.data("map-config");

        let mapConfig: LhlpMapConfig = new LhlpMapConfig();
        if(mapConfigB64) {
            var json: string = atob(mapConfigB64);
            if(json) mapConfig = JSON.parse(json);
            console.log(mapConfig);
        }

        let init = function (textpacks: TextPacks) {
            let map = new RootSiteMap(
                "theMap",
                maxFeatureCount,
                printOptions,
                textpacks.mapping,
                user,
                siteId,
                siteFolder,
                mapConfig
            );
        }
        TextPackLoader.load().then(init);
    }

});

import * as olProj from 'ol/proj';
import Feature from "ol/Feature";
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer} from 'ol/layer';
import {Icon, Text, Style, Fill, Stroke, Circle} from 'ol/style';
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import { IFeaturesSelectedEventArgs } from "esdm-map/dist/map/events/IFeaturesSelectedEventArgs";
import CircleStyle from "ol/style/Circle";
import { touchOnly } from "ol/events/condition";
import { LhlpMapContextMenu } from "./contextmenu/LhlpMapContextMenu";
export class RootSiteMap extends MapBase {
        
    private mfOptions: MapOptions;
    public map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private infoPopup: MapFeatureInfo;
    private initialised: boolean = false;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;   
    private gridRefFinder: GridRef;
    private logger: ILogger;   
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private wmsLayerGroupFactory: IWmsLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;    
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private recordList: MapListRecordsInViewport;
    private geoLocation: GeoLocation;
    private extentsNavigation: ExtentsNavigation;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mapViewSettingProvider: MapViewSettingsUrlProvider;
    private mapListRecordItem: IMapListRecordItem;
    private mapViewPermaLink: IMapViewPermaLink;
    private mousePosition: MousePosition;
    private mapToolTip: MapToolTip;   
    private openNames: LhlpGazetteer;

    public constructor(
        public mapElementId: string,       
        public maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: LhlpUser,
        public siteId: string,
        public siteFolder: string,
        public mapConfig: LhlpMapConfig)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = (): void => {
        if (!this.initialised) {
            //strip-loader should take this out for production
            console.log("Initialising root site map");                       

            this.layerConfigFactory = new DefaultLayerConfigurationFactory(this.siteId, this.siteFolder, this.mapConfig);
            this.vectorLayerGroupFactory = new VectorLayerGroupFactory(); 
            this.wmsLayerGroupFactory = new WmsLayerGroupFactory();
            this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, this.wmsLayerGroupFactory);
            this.baseLayerFactory = new LhlpBaseLayerFactory();
            this.featureLoader = new GeoJsonFeatureLoader();
         
            this.featureAdd = new FeatureAdd();

            this.mapFilter = new MapFilters();
            this.mapFilter.OgcFilter = new OgcMapFilter();
            this.mapFactory = new MapFactory();
            this.logger = new Logger();           
            this.styleFactory = new LhlpStyleFactory(this.mapConfig);
            this.resourcefactory = new LhlpResourcefactory(this.mappingTextPack);

            this.mfOptions = DefaultMapOptions.GetDefaultOptions(this.mapElementId, `${this.siteFolder}_MainMap`, this.tenantSettings?.MapSettings);           
            this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
            this.mfOptions.layerGroupCollection = this.layerGroups;
            
            this.mapViewSettingProvider = new MapViewSettingsUrlProvider();
            this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey, this.mapViewSettingProvider);
            
            this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
            //this.herMask = new YorkHerBoundary();
            this.mapContextMenu = new LhlpMapContextMenu(this.mappingTextPack);
                        
            this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
            this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);                        
                        
            this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);

            this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack,
                {
                    showOpenPanelByDefault: false,
                    showList: false,
                    rememberActivePanel: true
                });
            this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
            this.openNames = new LhlpGazetteer(this.map, this.tenantSettings?.MapSettings.GazetteerApiKey,this.mappingTextPack);

            if (this.printOptions.isPrintMap) {                
                this.printOptions.setMap(this.map);
            } 

            // this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
            this.mapListRecordItem = new LhlpMapListRecordItem(this.mappingTextPack);
            this.recordList = new MapListRecordsInViewport(this.map, this.mapStore, this.styleFactory, this.layerGroups.vectorLayerGroups, this.mappingTextPack, 13, this.mapListRecordItem);
            this.geoLocation = new GeoLocation(this.map, this.logger, this.mappingTextPack);
            // this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
            this.mousePosition = new MousePosition(this.map, this.mappingTextPack, "EPSG:27700");
            // this.mapViewPermaLink = new MapViewPermaLink(this.map, this.mapViewSettingProvider, this.mappingTextPack, { activePanel: "overlays" });

            if(!window.matchMedia("(pointer: coarse)").matches) {
                //add tooltip if not a touch screen
                this.mapToolTip = new MapToolTip(this.map, new ToolTipProvider(), new ToolTipOptions(10));
            }            
            
            this.infoPopup.onFeaturesSelected.subscribe(this.setSelectedFeaturesDynamicStyle);

            this.initialised = true;
        }
    }

    private setSelectedFeaturesDynamicStyle = (args: IFeaturesSelectedEventArgs): void => {
        let self = this;
        let features = args.features;
        for(let i=0;i<features.length;i++) {
            let style = this.getAssetSelectedDynamicStyle(features[i]);
            features[i].setStyle(style);
        }        
    }

    public getAssetSelectedDynamicStyle(feature: Feature): Style {
        
        let stylesConfig: LhlpMapConfig = this.mapConfig;
        //Root Site map only shows listed items so use the map legend colour (which uses root site listed status)
        let featureStatus: string   = "0"; //feature.get('asset_status_id');
        if(typeof(featureStatus) == 'undefined') featureStatus = "0";  //get the default colour of listed features (stored as statusId:0 for the map legend)      
        let iconChr: string         = '\uf60e';
        let iconColour: string      = '#F00000';

        let featureGeometryType: string = feature.getGeometry().getType();

        let featureSubType: string  = feature.get('recsubtype');
        let statusStyles: Array<LhlpStatusLookup> = stylesConfig.StatusStyles;
        if(statusStyles !== null) {
            for(let statusStyle of statusStyles) {
                if(statusStyle.StatusId === featureStatus) {
                    iconColour = statusStyle.StatusColour;
                    break;
                }
            }
        }

        let typeStyles: Array<LhlpTypeLookup> = stylesConfig.TypeStyles;
        if(typeStyles !== null) {
            for(let typeStyle of typeStyles) {
                if(typeStyle.TypeId == featureSubType) {
                    let c: string = typeStyle.TypeCharacter;
                    iconChr = String.fromCharCode(parseInt(c));
                    break;
                }
            }
        }

        if(featureGeometryType === 'Point' || featureGeometryType === 'MultiPoint') {
            let text = new Text({
                text: iconChr,
                font: '900 23px "Font Awesome 6 Pro"',
                textBaseline: 'bottom',
                offsetY: 11,
                fill: new Fill({
                    color: iconColour,
                }),
                stroke: new Stroke({
                    color: 'rgba(255,255,255,1)',
                    width: 5,
                })
            });

            let style = new Style({
                image: new Circle({
                    // stroke: new Stroke({
                    //     color: 'rgba(0,0,0,0.2)', //iconColour,
                    //     width: 3
                    // }),
                    radius: 20,
                    fill: new Fill({
                        color: 'rgba(0,0,0,0.2)'
                    })
                }),
                text: text 
            });
            return style;
        }
        //polygon or multipolygon selected style
        return new Style({
            stroke: new Stroke({
                color: iconColour,
                width: 3,
            }),
            fill: new Fill({
                color: 'rgb(0,0,0,0.2)',
            }),
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                    color: 'black',
                }),
            }),
        });

    }
    
    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {       

        //let isPublic = !this.isAuthenticated();
        let isPublic = true;
        let layerGroups = [];

        let AssetLayerGroupConfig: Array<IVectorLayerGroupConfig> = [
            this.layerConfigFactory.rootSiteLayerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeBuilding),
            this.layerConfigFactory.rootSiteLayerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeParkOrGarden),
            this.layerConfigFactory.rootSiteLayerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeLandmarkOrArtwork),
            this.layerConfigFactory.rootSiteLayerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeOtherSiteStructure),
        ];
        layerGroups.push({
            ref: "LHLP_Layers",
            name: "Local Heritage List",
            useAccordion: true,
            expandedOnFirstLoad: true,
            layerGroupConfigs: this.filterMapLayers(AssetLayerGroupConfig)
        });

        let AreaLayerGroupConfig: Array<IWmsLayerGroupConfig> = [
            this.layerConfigFactory.rootSiteLayerConfig(LhlpRecordType.LocalListArea),
            this.layerConfigFactory.rootSiteLayerConfig(LhlpRecordType.LocalListSubAreas)
        ];
        layerGroups.push(            {
            ref: "Area_layers",
            name: "Project Areas",
            useAccordion: true,
            expandedOnFirstLoad: false,
            layerGroupConfigs: this.filterMapLayers(AreaLayerGroupConfig)
        });

        // if(!isPublic) { //issue #603 has reverted this again!
            let NHLEGroupConfig: Array<IVectorLayerGroupConfig | IWmsLayerGroupConfig> = [                        
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.ScheduledMonument),
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.ListedBuilding),                 
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.RegisteredParkAndGarden),
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.Battlefield),        
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.ProtectedWreck),
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.WorldHeritageSite)            
            ];
            layerGroups.push({
                ref: "NHLE_layers",
                name: "NHLE",
                useAccordion: true,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(NHLEGroupConfig)
            });
        // }

        return layerGroups;
    }

}




